import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';
import { FormLabelRequiredText } from './FormLabelRequiredText.es.js';

const Styles = labelStyles("FormLabel", {
  root: css`
    display: grid;
    justify-content: start;
    grid-gap: var(--zds-space-2);
    grid-auto-flow: column;
    grid-auto-columns: auto;
    cursor: pointer;
    color: var(--zds-text-default);

    &[data-align-items='center'] {
      align-items: center;
    }

    &[data-align-items='start'] {
      align-items: start;
    }

    &[data-justify-content='start'] {
      justify-content: start;
    }

    &[data-justify-content='stretch'] {
      justify-content: stretch;
    }

    &[data-state~='selected'] {
      color: var(--zds-text-default);
    }

    &[data-state~='errored'] {
      color: var(--zds-status-error-stronger);
    }

    &[data-state~='disabled'] {
      cursor: not-allowed;
      color: var(--zds-text-weakest);
    }

    &[data-size='compact'] {
      ${Typography.MinimalPrint3}
    }

    &[data-size='small'] {
      ${Typography.SmallPrint3}
    }

    &[data-size='medium'] {
      ${Typography.Body2}
    }

    &[data-size='medium'][data-state='selected'] {
      ${Typography.Body3}
    }
  `,
  asterisk: css`
    ${Typography.Body2Multiline}
    color: var(--zds-ui-brand);
    text-decoration: none;
  `
});
const FormLabel = ({ children, alignItems = "center", htmlFor = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, isSelected = void 0, justifyContent = "start", requiredText = void 0, size = "medium" }) => {
  return jsx(
    "label",
    { css: Styles.root, "data-align-items": alignItems, "data-justify-content": justifyContent, "data-size": size, "data-state": [
      isSelected && "selected",
      isErrored && "errored",
      isDisabled && "disabled"
    ].filter(Boolean).join(" ") || void 0, "data-zds": true, htmlFor },
    children,
    isRequired && jsx("abbr", { css: Styles.asterisk, title: "required" }, "*"),
    isRequired ? requiredText ? jsx(FormLabelRequiredText, { isDisabled }, requiredText) : jsx(FormLabelRequiredText, { isDisabled }) : null
  );
};

export { FormLabel };
//# sourceMappingURL=FormLabel.es.js.map
